import { render, staticRenderFns } from "./copy-button.vue?vue&type=template&id=b9bc4854&"
import script from "./copy-button.vue?vue&type=script&lang=js&"
export * from "./copy-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports